<template>
  <div>
    <v-container>
      <v-btn
        class="ml-0"
        depressed
        :outline="graphtype != 'campaign'"
        :color="graphtype == 'campaign' ? 'primary' : 'grey'"
        @click="graphtype = 'campaign'"
      >
        {{ $t('Campaign') }}
      </v-btn>
      <v-btn
        depressed
        :outline="graphtype != 'user'"
        :color="graphtype == 'user' ? 'primary' : 'grey'"
        @click="graphtype = 'user'"
      >
        {{ $t('User') }}
      </v-btn>
    </v-container>
    <v-divider />
    <v-container>
      <date-filter
        ref="datefilter"
        v-model="selectedDate"
        :default-filter="'last_7_days'"
        @changeDate="onDateChanged"
      ></date-filter>
      <stat-card v-model="total_all_user" class="my-2" :loading="loading">
        {{ $t('total unique user') }}
      </stat-card>
      <h1 class="mt-4">{{ $t('Select BeaconID') }}</h1>
      <multiselect
        id="ajax"
        v-model="beaconSelect"
        class="mb-2"
        :options="items"
        :loading="isLoading"
        :show-no-results="true"
        :placeholder="$t('Beacon')"
        label="name"
        track-by="name"
        @select="onDateChanged"
      >
      </multiselect>
      <template v-if="graphtype == 'campaign'">
        <report-message-list
          :key="`report-user-by-date_${timestamp}`"
          v-model="total_all_user"
          :date="selectedDate"
          :beacon-select="beaconSelect"
        >
        </report-message-list>
      </template>
      <template v-if="graphtype == 'user'">
        <report-user-by-date
          :key="`report-user-by-date_${timestamp}`"
          v-model="total_all_user"
          :date="selectedDate"
          :beacon-select="beaconSelect"
        ></report-user-by-date>

        <report-user-by-time
          :key="`report-user-by-time_${timestamp}`"
          v-model="dataExportTime"
          :date="selectedDate"
          :beacon-select="beaconSelect"
        ></report-user-by-time>
      </template>
    </v-container>
    <!-- <report-conversation :type="'comment'"></report-conversation> -->
  </div>
</template>

<script>
// import ReportConversation from '../../view/analytics/ReportConversation.vue'
import ReportUserByDate from './ReportUserByDate'
import ReportUserByTime from './ReportUserByTime'
import ReportMessageList from './ReportMessageList'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import Multiselect from 'vue-multiselect'
import dayjs from 'dayjs'
import beaconApi from '@/api/beacon'
import { mapGetters } from 'vuex'
import StatCard from '@/components/view/dashboard/StatCard'
import { handleResponse, handleApiError } from '@/api/util'

export default {
  components: {
    // ReportConversation,
    DateFilter,
    ReportUserByDate,
    ReportUserByTime,
    ReportMessageList,
    Multiselect,
    StatCard
  },
  data() {
    return {
      total_all_user: 0,
      loading: false,
      beaconSelect: null,
      isLoading: false,
      items: [],
      timestamp: dayjs().format('x'),
      dataExportTime: null,
      dataExportDate: null,
      graphtype: 'campaign',
      selectedDate: {
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.getBeaconsList(1000, 0)
  },
  methods: {
    onDateChanged() {
      this.timestamp = dayjs().format('x')
    },
    async reportMessageBeaconsList() {
      const vm = this
      try {
        const response = await beaconApi.getReportMessageBeaconsList({
          data: {
            pageid: vm.selectedBot.pageid,
            params: { from_date: vm.selectedDate.start, to_date: vm.selectedDate.end }
          }
        })

        handleResponse(response)

        if (response && response.data && response.data.success) {
          console.log(response.data.result)
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async getBeaconsList(limit, offset) {
      const vm = this
      try {
        vm.isLoading = true

        const response = await beaconApi.getBeaconsList({
          pageId: vm.selectedBot.pageid,
          config: { limit: limit, offset: offset }
        })
        handleResponse(response)
        if (response && response.data && response.data.success) {
          vm.items = response.data.result
          vm.beaconSelect = vm.items[0]
          vm.isLoading = false
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Analytics.vue